import React from "react"
import { useSelector } from "react-redux"
import { Link } from "react-router-dom"
import { Button } from "../../components/Button"
import { Card } from "../../components/Card"
import { EmptyScreen } from "../../components/Empty"
import { HeaderContent } from "../../components/Header"
import noDashboards from "../../assets/img/noDashboards.svg"
import "./styles.scss"

const CardItem = ({
  description,
  id,
  image,
  config,
  isUserAdmin,
  selectedDashId,
  setSelectedDashId,
  index,
  isLoading,
}) => {
  return (
    <Link
      to={!isUserAdmin && `dashboard/${config ? "dynamic/" : ""}${id}`}
      onClick={() => setSelectedDashId({ id, config, index })}>
      <Card className="dash__card">
        {!isLoading && <img src={image} />}
        <div
          className={`dash__card__description ${
            selectedDashId?.index === index && "dash__card__description--active"
          }`}>
          <div>{description}</div>
        </div>
      </Card>
    </Link>
  )
}

export const DashboardList = ({
  data,
  isUserAdmin,
  toggleScreen,
  selectedDashId,
  setSelectedDashId,
  goToDashboard,
  isLoading
}) => {

  const sidebarCollapsed = useSelector(state => state.app.sidebarCollapsed)
  return (
    <section className="pageContainer dashboards">
      <HeaderContent>
        <div className="dashboard-list__actions">
          <div className="group__buttons">
            {isUserAdmin && selectedDashId && (
              <>
                <Button label="Visualizar Dashboard" color="orange" handleClick={goToDashboard} />
                <Button
                  label="Editar Dashboard"
                  color="orange"
                  handleClick={() => toggleScreen()}
                />
              </>
            )}
            {isUserAdmin && (
              <Button
                label="Novo Dashboard"
                color="orange"
                handleClick={() => toggleScreen(true)}
              />
            )}
          </div>
        </div>
      </HeaderContent>
      <Card className={`cardPage no-border ${data?.length > 0 && "align-baseline"}`}>
        <>
          <div className={`dashboards-content-container ${sidebarCollapsed ? "expand-cards" : ""}`}>
            {Array.isArray(data) &&
              data?.map((item, index) => (
                <div className="dashboards-content__card">
                  <CardItem
                    {...item}
                    {...{ selectedDashId, isLoading, setSelectedDashId, isUserAdmin, index }}
                  />
                </div>
              ))}
          </div>
          {data?.length === 0 && (
              <div className="dashboards-content-container empty">
                <EmptyScreen
                  image={noDashboards}
                  label="Não há dashboards configurados para este projeto"
                />
              </div>
            )}
        </>
      </Card>
    </section>
  )
}
